import { Component, computed, effect, input, linkedSignal, output } from '@angular/core';
import { Character } from 'src/app/features/characters/types/character';
import { IonListHeader, IonList, IonItem, IonLabel, IonNote } from '@ionic/angular/standalone';
import { getElementByPath } from 'src/app/features/characters/utils/sheetParser';
import { Sheet_Base_Types } from 'src/app/features/characters/types/sheet/base_types';
import { Sheet_Composed_Types } from 'src/app/features/characters/types/sheet/composed_types';
import {
  Sheet_Group,
  Sheet_Page,
} from 'src/app/features/characters/types/sheet/group_types';
import { ReferenceToSheetFragment } from 'operationlib';
import { TRANSLATE_IMPORTS } from 'src/app/features/i18n/translate-imports';

@Component({
  selector: 're-compile-stat',
  imports: [IonListHeader, IonList, IonItem, IonLabel, IonNote, ...TRANSLATE_IMPORTS],
  templateUrl: './compile-stat.component.html',
  styleUrls: [
    './compile-stat.component.scss',
    '../../styles/operation-sheet-list.scss',
  ],
})
export class CompileStatComponent {
  path = input.required<string[]>();
  operation = input.required<ReferenceToSheetFragment>();
  character = input.required<Character>();
  operationName = input<string>('');
  statLabel = input<string>('');
  /** Contextual hint from `h:fieldName:…` modifier for this sheet reference. */
  statHint = input<string>('');
  /** When true, the stat picker slide is visible — resets drill-down state. */
  active = input(false);
  compiled = output<string[]>();

  selectedPath = linkedSignal(() => this.initialPathPrefix());

  constructor() {
    effect(() => {
      if (this.active()) {
        this.selectedPath.set(this.initialPathPrefix());
      }
    });
  }

  private initialPathPrefix(): string[] {
    let path = this.path();
    let variantIndex = path.findIndex(
      (v) => v.includes('@') || v.includes('*'),
    );
    return path.slice(0, variantIndex === -1 ? undefined : variantIndex);
  }

  list = computed(() => {
    let el = getElementByPath(this.selectedPath(), this.character());
    if (el?.type === 'page') return el.groups;
    else if (el?.type === 'arrayMixed' || el?.type === 'group') return el.list;
    else return [];
  });

  selectStat(
    stat:
      | Sheet_Base_Types
      | Sheet_Composed_Types<any>
      | Sheet_Group
      | Sheet_Page
  ) {
    let identifier = stat.identifier;
    let nextPathIndex = this.selectedPath().length + 1;
    let original = this.path()[this.selectedPath().length];
    if (original?.includes('$')) identifier = '$' + identifier;
    let newPath = [...this.selectedPath(), identifier];
    this.selectedPath.set(newPath);
    if (
      this.path()[nextPathIndex] &&
      !(
        this.path()[nextPathIndex].includes('@') ||
        this.path()[nextPathIndex].includes('*')
      )
    ) {
      this.selectStat(
        getElementByPath(
          [...this.selectedPath(), this.path()[nextPathIndex]],
          this.character()
        )!
      );
    }

    if (this.path()[nextPathIndex] === undefined) {
      let newEl = getElementByPath(newPath, this.character());
      if (
        newEl?.type !== 'arrayMixed' &&
        newEl?.type !== 'group' &&
        newEl?.type !== 'page'
      ) {
        this.compiled.emit(this.selectedPath());
      }
    }
  }
}
